import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SocialIcon } from "react-social-icons";
import { websiteDetail, websiteSocialLinks } from "../utils/common.data";
import "./header.css";
import { getUserDetail } from "../utils/api.functions";

const Header = ({ isAuthenticated, setIsAuthenticated }) => {
  const apikey = sessionStorage.getItem("key");
  const userid = sessionStorage.getItem("userid");
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const location = useLocation(); // Get the current path

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const closeNavbar = () => {
    setIsCollapsed(true);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      getUserData();
    }, 5000); // 50 seconds in milliseconds
    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [userid, apikey]);

  const getUserData = async () => {
    if (userid && apikey) {
      try {
        const response = await getUserDetail(
          {
            user_id: userid,
          },
          apikey
        );
        if (response.status === 200) {
          const value = response.data.resDecrypt.response;
          sessionStorage.setItem(
            "wmt",
            value[0]?.u_wallet ? value[0]?.u_wallet : "0"
          );
        }

        if (response?.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          setIsAuthenticated(false);
          navigate("/login");
          window.location.reload(); // This will reload the page after navigation
        }
      } catch (error) {
        console.log("User fetch ErrorError::", error);

        if ("Request failed with status code 401" == error.message) {
          sessionStorage.clear();
          localStorage.clear();
          setIsAuthenticated(false);
          window.location.href = "/login";
        }
      }
    }
  };

  return (
    <header id="scroll-top-marker" className="tj-header">
      {/* <!--Header Content Start--> */}
      <div className="container">
        <div className="row header_row_main">
          {/* <!--Toprow Content Start--> */}
          <div className="col-md-7 col-sm-6 col-xs-12 main-logo">
            <div>
              <span>
                <Link to="/">
                  <img
                    className="cursor-pointer"
                    style={{
                      height: "100px",
                      display: "block",
                    }}
                    alt={websiteDetail.title}
                    title={websiteDetail.title}
                    src="image/logo.png"
                  />
                </Link>
              </span>
            </div>

            {/* <!--Logo End--> */}
          </div>
          <div className="social_icon_main">
            <span className="social_icon_main_header">Connect with us</span>

            <div className="social-css social_icon_main_icons">
              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.facebook}
                  rel="noopener noreferrer"
                />
              </span>
              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.pinterest}
                  rel="noopener noreferrer"
                />
              </span>

              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.instagram}
                  rel="noopener noreferrer"
                />
              </span>
              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.twitter}
                  rel="noopener noreferrer"
                />
              </span>

              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.youtube}
                  rel="noopener noreferrer"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="tj-nav-row">
        <div className="container">
          <div className="row">
            <div className="tj-nav-holder">
              <nav className="navbar navbar-default">
                <div
                  className="navbar-header"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className="logo-mobile"
                    style={{
                      width: "40%",
                      margin: "auto",
                      marginTop: 0,
                      marginBottom: 0,
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: !["/term_condition", "/privacy_policy","/about_us"].includes(location.pathname) ? "18%" :"0",
                    }}
                  >
                    <img
                      src="image/mlogo.png"
                      height="60px"
                      width="150px"
                      style={{ objectFit: "contain" }}
                      alt={websiteDetail.title}
                      title={websiteDetail.title}
                    />
                  </div>

                  {!["/term_condition", "/privacy_policy","/about_us"].includes(location.pathname) && <button
                    type="button"
                    className="navbar-toggle collapsed"
                    // data-toggle="collapse"
                    // data-target="#tj-navbar-collapse"
                    aria-expanded={!isCollapsed}
                    onClick={toggleNavbar}
                  >
                    <span className="sr-only">Menu</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>}
                </div>

                {/* <!-- Navigation Content Start --> */}

                <div
                  className={`collapse navbar-collapse ${
                    isCollapsed ? "" : "in"
                  }`}
                  id="tj-navbar-collapse"
                >
                  <ul className="nav navbar-nav">
                    <li className="dropdown" onClick={closeNavbar}>
                      <Link to="/">Home</Link>
                    </li>
                    <li onClick={closeNavbar}>
                      <Link to="/about-us">About Us</Link>
                    </li>

                    <li className="dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        onClick={closeNavbar}
                      >
                        Services <span className="caret"></span>
                      </Link>
                      <ul className="dropdown-menu">
                      <li className={location.pathname === "/services" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/services">All Services</Link>
                      </li>
                      {/* <li className={location.pathname === "/luggage-policy" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/luggage-policy">Luggage Policy</Link>
                      </li>
                      <li className={location.pathname === "/cancellation-policy" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/cancellation-policy">Cancellation Policy</Link>
                      </li> */}
                      <li className={location.pathname === "/safety-onboard" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/safety-onboard">Safety Onboard</Link>
                      </li>
                      {/* <li className={location.pathname === "/services-on-our-vehicle" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/services-on-our-vehicle">Services on our vehicle</Link>
                      </li> */}
                      <li className={location.pathname === "/how-to-book" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/how-to-book">How to book</Link>
                      </li>
                      <li className={location.pathname === "/sustainability" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/sustainability">Sustainability</Link>
                      </li>
                      {/* <li className={location.pathname === "/customer-satisfaction" ? "active" : ""} onClick={closeNavbar}>
                        <Link to="/customer-satisfaction">Customer satisfaction</Link>
                      </li> */}
                    </ul>
                    </li>

                    <li onClick={closeNavbar}>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>

                    <li onClick={closeNavbar}>
                      <Link to="/partner-with-us">Partner With Us</Link>
                    </li>

                    <li onClick={closeNavbar}>
                      <Link to="/apps">Download</Link>
                    </li>

                    {!isAuthenticated ? (
                      <li onClick={closeNavbar}>
                        <Link to="/login">Login</Link>
                      </li>
                    ) : (
                      <li onClick={closeNavbar}>
                        <Link to="/profile">My Account</Link>
                      </li>
                    )}
                    <li
                      className="header_mobile_dropdown_btn"
                      onClick={closeNavbar}
                    >
                      <Link to="/booknow">Book Now</Link>
                    </li>
                  </ul>
                </div>
                {/* <!-- Navigation Content Start --> */}
              </nav>
              {/* <!--Menu Holder End--> */}
              <div className="book_btn">
                <Link to="/booknow">
                  Book Now{" "}
                  <i
                    className="fas fa-arrow-circle-right"
                    aria-hidden="true"
                  ></i>
                </Link>
              </div>
            </div>
            {/*<!--Nav Holder End--> */}
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
